import React, { useState } from 'react'
import { Button } from '@enamelai/design-system'
import ScheduleReportModal from '../ScheduleReportModal.component'

type ScheduleReportButtonProps = {
  handleScheduleReport: (
    viewId?: string,
    scheduleId?: string,
    scheduleDetails?: any,
    message?: string,
  ) => Promise<void>
  selectedViewId: string
}

const ScheduleReportButton = ({
  handleScheduleReport,
  selectedViewId,
}: ScheduleReportButtonProps): React.ReactElement => {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false)
  return (
    <>
      <Button
        type="button"
        variant="primary"
        onClick={() => setScheduleModalOpen(true)}
      >
        Schedule this report
      </Button>
      {scheduleModalOpen && (
        <ScheduleReportModal
          show={scheduleModalOpen}
          onHide={() => setScheduleModalOpen(false)}
          reportName={(() => {
            const reportText =
              document?.querySelector('.reports-preview-form__title')
                ?.textContent || ''
            return (
              reportText?.charAt(0).toUpperCase() +
                reportText?.slice(1).toLowerCase() || ''
            )
          })()}
          onSaveSchedule={(line, scheduleDetails) => {
            handleScheduleReport(
              selectedViewId,
              undefined,
              scheduleDetails,
              line,
            )
          }}
        />
      )}
    </>
  )
}

export default ScheduleReportButton
